function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.182 29.94C32.692 27.45 31.762 27.59 28.532 29.3C26.562 30.34 25.832 29.87 22.972 27.015C20.113 24.155 19.642 23.415 20.687 21.457C22.397 18.223 22.537 17.294 20.047 14.807C18.627 13.387 18.177 12.987 17.187 12.987C16.461 12.987 15.687 13.457 14.522 14.627C12.68 16.467 12.534 18.047 13.922 21.127C15.023 23.567 16.702 26.787 19.932 30.027C23.162 33.257 26.382 34.943 28.832 36.037C31.352 37.167 33.182 37.577 35.332 35.437C36.502 34.267 36.972 33.497 36.972 32.767C36.972 31.767 36.562 31.317 35.152 29.907"
});

function SvgIc5D5F9A72Fc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F9A72Fc0611Eb9A030242Ac130003);
export default ForwardRef;